var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefeated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0703125,
    y: 0.000488281,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#C5221F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07031 2.00049V6.2862M5.07031 7.57192V8.00049V7.14335",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefeated);
export default __webpack_public_path__ + "static/media/defeated.82bf60d914d290b90b37c449f84b3bbb.svg";
export { ForwardRef as ReactComponent };